export default __webpack_public_path__ + "images/a8de7b19e6b093ca3c454afe8fcb2019-Barlow-Bold.woff";